/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import style from './tags.module.scss';
import { useAppSelector } from 'store/hooks';
import { selectTagsPage } from 'store/tagsSlice';
import sortBy from 'lodash-es/sortBy';
import isEmpty from 'lodash-es/isEmpty';
import TagsSearch from 'controls/search/tagsSearch/tagsSearch';
import { useSearchControl } from 'hooks/useSearchControl';
import { isSearchEnoughtLarge } from 'utils/utils';
import cx from 'classnames';
import TagsPageContainer from 'components/tags/tagsPageContainer';
import { Tags as TypeTags } from 'store/types';

export default function Tags() {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const page = useAppSelector(selectTagsPage);
  const [match, setMatch] = useState<TypeTags>({});
  const tags = page?.data;

  const isSearchMode = isSearchEnoughtLarge(search);
  const content = isSearchMode ? match : tags;
  const sorted = sortBy(content, ['description']);

  return (
    <div className={cx(style.container, 'adaptive-tagsSearch__container')}>
      <div className={cx(style.search, 'adaptive-tagsSearch__search')}>
        <span className={'font32 fontBold'}>Теги</span>
        <TagsSearch
          className={'adaptive-tagsSearch__searchControlTags'}
          initialSearch={search}
          onOpenChange={(_isOpen) => setIsOpen(_isOpen)}
          tagsStrategy={useSearchControl.bind(null, {
            onSearchChange: (s) => {
              setSearch(s);
            },
            onMatchChange: (m) => {
              setMatch(m);
            },
            matchPosition: 'any',
          })}
        ></TagsSearch>
      </div>

      <div className={cx(style.result, isSearchMode ? style.isSearch : '')}>
        {isSearchMode ? (
          <span
            className={'fontBold font20'}
          >{`Результат поиска по «${search}»:`}</span>
        ) : (
          ''
        )}
        {isEmpty(content) ? (
          <span className={'font16 fontPale'}>
            {isSearchMode
              ? 'К сожалению, по вашему запросу ничего не найдено. Попробуйте другой запрос'
              : 'Список тегов пуст, пожалуйста, загрузите ресурсы с указанием тегов, затем, они будут доступны на этой странице'}
          </span>
        ) : (
          <>
            <TagsPageContainer
              isBlockAnime={isOpen}
              tags={sorted}
            ></TagsPageContainer>
          </>
        )}
      </div>
    </div>
  );
}
